// fetch combinations JSON as early as possible so it's ready by Q3
document.addEventListener('DOMContentLoaded', () => {
  if (!window.quizConfig) return;

  const firstConfig = Object.values(window.quizConfig)[0];
  if (!firstConfig || !firstConfig.combinationsUrl) return;

  fetch(firstConfig.combinationsUrl)
    .then(r => {
      if (!r.ok) throw new Error(`combinations fetch failed: ${r.status}`);
      return r.json();
    })
    .then(data => {
      if (!data || typeof data.questions !== 'object') {
        throw new Error('combinations JSON missing "questions"');
      }
      window.quizCombinations = data;
    })
    .catch(err => {
      // shade filtering/result computation fall back gracefully without this data,
      // but log so a broken/misconfigured combinations file doesn't fail silently
      console.warn('[quiz] failed to load shade combinations:', err);
    });
});

document.addEventListener('DOMContentLoaded', () => {
  if (!window.quizConfig) return;

  Object.keys(window.quizConfig).forEach((id) => {
   try {
    const config = window.quizConfig[id];
    if (!config || !config.sectionId) {
      console.error(`[quiz] invalid config for "${id}" — missing sectionId`);
      return;
    }

    const section = document.querySelector(`#Quiz--${config.sectionId}`);
    if (!section) return;

    const entrance = section.querySelector('.quiz-entrance');
    const steps = Array.from(section.querySelectorAll('.quiz-step'));
    const startBtn = section.querySelector('.quiz-start');
    const globalResultBtn = section.querySelector('#getResultBtn') || section.querySelector('.get-result-btn');
    const defaultUrl = globalResultBtn ? globalResultBtn.getAttribute('href') : '/pages/default-result';

    const shadeModal = section.querySelector('[data-shade-modal]');
    const shadeModalGrid = section.querySelector('[data-shade-modal-grid]');
    const shadeModalOpenBtn = section.querySelector('[data-shade-modal-open]');
    const shadeModalCloseBtn = section.querySelector('[data-shade-modal-close]');

    const totalSteps = steps.length;
    let currentStep = 0;
    const selections = {}; // { stepIndex: value }
    const navHistory = []; // tracks visited indices for conditional Q5 navigation

    // auto-assign step numbers
    steps.forEach((step, i) => { step.dataset.step = i + 1; });

    // effective total: exclude conditional steps unless a triggering Q4 option is selected
    function getEffectiveTotalSteps() {
      let triggersExtra = false;
      steps.forEach(s => {
        if (isShadeStep(s) || s.dataset.conditional === 'true') return;
        if (s.querySelectorAll('input[type="radio"]').length === 0) return;
        const sel = s.querySelector('label.quiz_option.selected');
        if (sel && sel.dataset.extraStep === 'true') triggersExtra = true;
      });
      return steps.filter(s => s.dataset.conditional !== 'true' || triggersExtra).length;
    }

    // position in the visible path (unvisited conditional steps don't count)
    function getEffectivePosition() {
      let pos = 0;
      for (let i = 0; i <= currentStep; i++) {
        if (steps[i].dataset.conditional === 'true' && !navHistory.includes(i)) continue;
        pos++;
      }
      return pos;
    }

    // ---- step counter display ----
    function updateStepCounter() {
      const activeStep = steps[currentStep];
      if (!activeStep) return;

      const currentEl = activeStep.querySelector('.current-step');
      const totalEl = activeStep.querySelector('.total-steps');
      if (currentEl) currentEl.textContent = getEffectivePosition();
      if (totalEl) totalEl.textContent = getEffectiveTotalSteps();

      section.querySelectorAll('.previous_step').forEach(btn => {
        btn.style.visibility = currentStep === 0 ? 'hidden' : 'visible';
      });
    }

    // ---- progress bar (all bars across section) ----
    function updateProgress() {
      const total = getEffectiveTotalSteps();
      const progressPercent = total > 0 ? (getEffectivePosition() / total) * 100 : 0;
      section.querySelectorAll('.progress-fill').forEach(bar => {
        bar.style.width = `${progressPercent}%`;
      });
    }

    // a step is a shade-voting step if any option has non-empty data-results
    function isShadeStep(step) {
      return Array.from(step.querySelectorAll('label.quiz_option')).some(
        opt => opt.dataset.results && opt.dataset.results.trim() !== ''
      );
    }

    // a corrector step is Q4 (has at least one option with data-extra-step) or Q5 (conditional)
    function isCorrectorStep(step) {
      return step.dataset.conditional === 'true' ||
        Array.from(step.querySelectorAll('label.quiz_option')).some(opt => opt.dataset.extraStep === 'true');
    }

    // ---- Q3: show only shades in the intersection of Q1 family and Q2 undertone ----
    function filterShadeOptions(step) {
      const comb = window.quizCombinations;
      if (!comb) return; // JSON not ready yet — show all, will re-filter on next entry

      let shadeCount = 0, q1Value = '', q2Value = '';
      for (const s of steps) {
        if (s === step) break;
        if (isCorrectorStep(s) || s.querySelectorAll('input[type="radio"]').length === 0) continue;
        shadeCount++;
        const sel = s.querySelector('label.quiz_option.selected input');
        const val = sel ? sel.value.trim().toLowerCase() : '';
        if (shadeCount === 1) q1Value = val;
        else if (shadeCount === 2) q2Value = val;
      }

      if (!q1Value) return;

      const questions = comb.questions || {};
      const q1Handles = new Set(Object.keys((questions.q1 || {})[q1Value] || {}));
      const q2Handles = q2Value
        ? new Set(Object.keys((questions.q2 || {})[q2Value] || {}))
        : null;
      const valid = q2Handles
        ? new Set([...q1Handles].filter(h => q2Handles.has(h)))
        : q1Handles;

      step.querySelectorAll('label.quiz_option').forEach(opt => {
        const input = opt.querySelector('input');
        const handle = input ? input.value.trim().toLowerCase() : '';
        opt.style.display = valid.size === 0 || valid.has(handle) ? '' : 'none';
      });

      // center options when fewer than 3 are visible
      const container = step.querySelector('.step_choices_conatiner');
      if (container) {
        const visibleCount = [...step.querySelectorAll('label.quiz_option')].filter(o => o.style.display !== 'none').length;
        container.classList.toggle('few-options', visibleCount < 3);
      }
    }

     // ---- Q5: show only options whose data-trigger matches the Q4 selection ----
    function filterConditionalOptions(step) {
      // navHistory is [..., Q4_idx, Q5_idx] at this point
      // so the step that triggered Q5 is always navHistory[-2]
      const triggerIdx = navHistory[navHistory.length - 2];
      const q4Value = (triggerIdx !== undefined && selections[triggerIdx])
        ? selections[triggerIdx]
        : '';

      step.querySelectorAll('label.quiz_option').forEach(opt => {
        const trigger = (opt.dataset.trigger || '').trim().toLowerCase();
        if (!trigger || trigger === q4Value) {
          opt.style.display = '';
        } else {
          opt.style.display = 'none';
        }
      });
    };

    // ---- next reachable step (skips conditional Q5 unless current selection triggers it) ----
    function nextStepIndex(from) {
      if (!steps[from]) return -1;
      const sel = steps[from].querySelector('label.quiz_option.selected');
      const triggersExtra = sel && sel.dataset.extraStep === 'true';
      for (let i = from + 1; i < steps.length; i++) {
        if (steps[i].dataset.conditional === 'true' && !triggersExtra) continue;
        return i;
      }
      return -1;
    }

    function getShadeComparisonStep() {
      return steps.find(step => step.dataset.filterOptions === 'true') || null;
    }

    function syncShadeModalSelection() {
      if (!shadeModalGrid) return;

      shadeModalGrid.querySelectorAll('[data-shade-modal-value]').forEach(item => {
        const value = item.dataset.shadeModalValue;
        const isSelected = selections[currentStep] === value;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    function buildShadeModal() {
      const shadeStep = getShadeComparisonStep();
      if (!shadeStep || !shadeModalGrid) return;

      shadeModalGrid.innerHTML = '';

      shadeStep.querySelectorAll('label.quiz_option').forEach(option => {
        const input = option.querySelector('input[type="radio"]');
        if (!input) return;

        const value = input.value.trim().toLowerCase();
        const name = (option.querySelector('.option_name') || input).textContent.trim() || input.value;
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'quiz-shade-modal__item';
        item.dataset.shadeModalValue = value;
        item.setAttribute('aria-pressed', 'false');

        const media = option.querySelector('.dt-media, .mb-media, .quiz_option-icon');
        if (media) {
          const mediaClone = media.cloneNode(true);
          mediaClone.removeAttribute('id');
          mediaClone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          item.appendChild(mediaClone);
        }

        const label = document.createElement('span');
        label.className = 'quiz-shade-modal__item-name';
        label.textContent = name;
        item.appendChild(label);

        item.addEventListener('click', () => {
          if (shadeModal && shadeModal.open) shadeModal.close();
          input.click();
        });

        shadeModalGrid.appendChild(item);
      });

      syncShadeModalSelection();
    }

    function openShadeModal() {
      if (!shadeModal || !shadeModalGrid) return;

      buildShadeModal();

      if (shadeModalGrid.children.length === 0) {
        console.error('[quiz] shade modal has no items to show — check the Q3 step has "Filter options" enabled and shade option blocks');
        return;
      }

      if (typeof shadeModal.showModal === 'function') {
        shadeModal.showModal();
      } else {
        shadeModal.setAttribute('open', '');
      }
    }

    function closeShadeModal() {
      if (!shadeModal) return;

      if (shadeModal.open && typeof shadeModal.close === 'function') {
        shadeModal.close();
      } else {
        shadeModal.removeAttribute('open');
      }
    }

    function computeResult() {
      try {
        const comb = window.quizCombinations;
        if (!comb || typeof comb.questions !== 'object') return defaultUrl;

        const compactCounts = {};
        const correctorCounts = {};
        let shadeStepCount = 0;

        steps.forEach((step, stepIdx) => {
          if (step.querySelectorAll('input[type="radio"]').length === 0) return; // email step
          if (step.dataset.conditional === 'true' && !navHistory.includes(stepIdx)) return; // unvisited Q5

          const sel = step.querySelector('label.quiz_option.selected input');
          if (!sel) return;
          const answer = sel.value.trim().toLowerCase();

          if (!isCorrectorStep(step)) {
            shadeStepCount++;
            const qKey = 'q' + shadeStepCount;
            const votes = (comb.questions[qKey] || {})[answer] || {};
            Object.entries(votes).forEach(([h, w]) => {
              compactCounts[h] = (compactCounts[h] || 0) + w;
            });
          } else {
            const qKey = step.dataset.conditional === 'true' ? 'q5' : 'q4';
            const votes = (comb.questions[qKey] || {})[answer] || {};
            Object.entries(votes).forEach(([h, w]) => {
              correctorCounts[h] = (correctorCounts[h] || 0) + w;
            });
          }
        });

        if (Object.keys(compactCounts).length === 0) return defaultUrl;

        const compact = Object.entries(compactCounts).sort((a, b) => b[1] - a[1])[0][0];
        const correctorEntries = Object.entries(correctorCounts).sort((a, b) => b[1] - a[1]);
        const corrector = correctorEntries.length ? correctorEntries[0][0] : '';

        if (!config.resultBaseUrl) {
          console.error('[quiz] missing resultBaseUrl in config, falling back to default URL');
          return defaultUrl;
        }

        let url = `${config.resultBaseUrl}?compact=${compact}`;
        if (corrector) url += `&corrector=${corrector}`;
        return url;
      } catch (err) {
        console.error('[quiz] computeResult failed, falling back to default URL:', err);
        return defaultUrl;
      }
    }

    // ---- show step ----
    function showStep(index) {
      if (!steps[index]) {
        console.error(`[quiz] showStep called with invalid index: ${index}`);
        return;
      }
      steps.forEach((s, i) => s.classList.toggle('active', i === index));
      currentStep = index;
      updateProgress();
      updateStepCounter();

      // Q3: filter shade options to the family chosen in Q1 (only on steps with filter_options enabled)
      if (steps[index].dataset.filterOptions === 'true') {
        filterShadeOptions(steps[index]);
      }

      // Q5: filter to only show options matching the Q4 selection
      if (steps[index].dataset.conditional === 'true') {
        filterConditionalOptions(steps[index]);
      }

      // restore checked state & selected class
      const radios = Array.from(steps[currentStep].querySelectorAll('input[type="radio"]'));
      radios.forEach(r => {
        const label = r.closest('label');
        if (selections[currentStep] !== undefined && r.value.trim().toLowerCase() === selections[currentStep]) {
          r.checked = true;
          if (label) label.classList.add('selected');
        } else {
          r.checked = false;
          if (label) label.classList.remove('selected');
        }
      });

      // last step (email form) — set quizFinalRedirect for the MutationObserver redirect
      if (currentStep === totalSteps - 1) {
        const url = computeResult();
        window.quizFinalRedirect = url;
        const stepResultBtn = steps[currentStep].querySelector('#getResultBtn, .get-result-btn');
        if (stepResultBtn) { stepResultBtn.setAttribute('href', url); stepResultBtn.style.display = 'none'; }
        if (globalResultBtn) { globalResultBtn.setAttribute('href', url); globalResultBtn.style.display = 'none'; }
      } else {
        const stepResultBtn = steps[currentStep].querySelector('#getResultBtn, .get-result-btn');
        if (stepResultBtn) stepResultBtn.style.display = 'none';
        if (globalResultBtn) globalResultBtn.style.display = 'none';
      }
    }

    // ---- start button ----
    if (startBtn) {
      startBtn.addEventListener('click', e => {
        e.preventDefault();
        if (entrance) entrance.classList.add('hidden');
        navHistory.length = 0;
        navHistory.push(0);
        showStep(0);
      });
    }

    // ---- radio selections ----
    steps.forEach((step, index) => {
      const radios = Array.from(step.querySelectorAll('input[type="radio"]'));
      const stepResultBtn = step.querySelector('#getResultBtn, .get-result-btn');

      radios.forEach(radio => {
        function handleSelection() {
          selections[index] = radio.value.trim().toLowerCase();

          radios.forEach(r => {
            const lab = r.closest('label');
            if (lab) lab.classList.toggle('selected', r === radio);
          });

          if (window.innerWidth < 769) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }

          // clear conditional step selections only when on Q4 and a non-triggering option is chosen
          // never clear when already inside Q5 (the conditional step itself)
          const thisLabel = radio.closest('label');
          const triggersExtra = thisLabel && thisLabel.dataset.extraStep === 'true';
          const onConditionalStep = steps[index].dataset.conditional === 'true';
          if (!triggersExtra && !onConditionalStep) {
            steps.forEach(s => {
              if (s.dataset.conditional !== 'true') return;
              s.querySelectorAll('label.quiz_option').forEach(l => l.classList.remove('selected'));
              s.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });
              delete selections[steps.indexOf(s)];
            });
          }

          const next = nextStepIndex(index);
          if (next !== -1) {
            if (navHistory[navHistory.length - 1] !== next) navHistory.push(next);
            showStep(next);
          } else {
            const url = computeResult();
            window.quizFinalRedirect = url;
            if (stepResultBtn) {
              stepResultBtn.setAttribute('href', url);
              stepResultBtn.style.display = 'inline-block';
            } else if (globalResultBtn) {
              globalResultBtn.setAttribute('href', url);
              globalResultBtn.style.display = 'inline-block';
            }
          }
        }

        radio.addEventListener('change', handleSelection);
        radio.addEventListener('click', () => { if (radio.checked) handleSelection(); });
      });
    });

    // ---- back button ----
    section.addEventListener('click', e => {
      if (!e.target.classList.contains('previous_step')) return;

      navHistory.pop();
      const prev = navHistory[navHistory.length - 1];

      if (prev === undefined) {
        if (entrance) entrance.classList.remove('hidden');
        steps.forEach(s => s.classList.remove('active'));
        if (globalResultBtn) globalResultBtn.style.display = 'none';
        steps.forEach(s => {
          const btn = s.querySelector('#getResultBtn, .get-result-btn');
          if (btn) { btn.style.display = 'none'; btn.removeAttribute('href'); }
        });
      } else {
        showStep(prev);
      }
    });

    if (shadeModalOpenBtn) {
      shadeModalOpenBtn.addEventListener('click', openShadeModal);
    }

    if (shadeModalCloseBtn) {
      shadeModalCloseBtn.addEventListener('click', closeShadeModal);
    }

    if (shadeModal) {
      shadeModal.addEventListener('click', e => {
        if (e.target === shadeModal) closeShadeModal();
      });
    }

    // ---- restore pre-selected answers on page load ----
    steps.forEach((step, i) => {
      const pre = step.querySelector('input[type="radio"]:checked');
      if (pre) {
        selections[i] = pre.value.trim().toLowerCase();
        const label = pre.closest('label');
        if (label) label.classList.add('selected');
      }
    });
   } catch (err) {
     // isolate failures to this quiz instance so other sections on the page still work
     console.error(`[quiz] failed to initialize section "${id}":`, err);
   }
  });
});